<template>
  <v-container class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Customers Search</div>
        <div>
          <bread-crumb :bread-crumbs="['List of Customers']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <loading
          :active="isloadagents"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-form>
          <v-row row-gutters class="mt-1">
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                attach
                :items="[
                  { text: 'Individual', value: 'IND' },
                  { text: 'Bussiness', value: 'BUS' },

                  { text: 'All', value: 'ALL' },
                ]"
                placeholder="Customer Type"
                v-model="searchInputs.customer_type"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                attach
                :items="listOfFilters"
                v-model="userSelectedFilter"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                :placeholder="
                  userSelectedFilter === 'Customer Name'
                    ? 'Enter Customer Name'
                    : 'Enter Customer ID'
                "
                v-model="searchInputs.customer_id"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <div class="d-flex">
              <div>
                <v-btn
                  depressed
                  small
                  class="mx-2 ms-3 primary text-capitalize"
                  @click="getRemitteList()"
                  >Get Results</v-btn
                >
              </div>
            </div>
          </v-row>
        </v-form>
        <v-row row-gutters class="mt-3">
          <v-spacer></v-spacer>
          <v-col cols="12" lg="4" xs="12">
            <v-btn
              depressed
              color="primary"
              small
              @click="$router.push('/CustomerMain')"
              ><v-icon small class="me-1">mdi-account-plus</v-icon>Add Customer
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records."
        item-key="user_id"
        dense
      >
        <template v-slot:item.user_type="{ item }">
          <v-chip
            label
            small
            outlined
            :color="item.user_type == 'Individual' ? 'primary' : 'secondary'"
          >
            {{ item.user_type }}
          </v-chip>
        </template>
        <template v-slot:item.no_of_bene="{ item }">
          <v-chip small color="primary" @click="$router.push('/BeneSummary')">
            {{ item.no_of_bene }}
          </v-chip>
        </template>

        <template v-slot:item.Is_Negativelisted="{ item }">
          <v-icon :color="item.Is_Negativelisted === 2 ? 'red' : 'green'"
            >mdi-flag</v-icon
          >
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            color="grey"
            title="View Details"
            class="mr-2"
            @click="nextpage(item)"
          >
            mdi-chevron-right
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Customer Summary",
  data: () => {
    return {
      itemsPerPage: "10",
      headers: [
        { text: "Customer ID", value: "user_id" },
        { text: "Customer Name", value: "name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: "Nationality", value: "nationality" },
        { text: "Phone Number", value: "mobile_number" },
        { text: "Account Status", value: "account_status" },
        { text: "No of Beneciciaries", value: "no_of_bene" },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 150,
          align: "center",
        },
      ],
      userList: [
        {
          user_id: "1600092652",
          name: "John Dee",
          user_type: "Individual",
          id_number: "251425415",
          nationality: "Malaysian",
          mobile_number: "+606465749",
          account_status: "Approved",
          no_of_bene: "2",
        },
      ],
      tatalcustomerslist: [],
      search: "",
      listOfFilters: ["Customer Name", "Phone Number"],
      userSelectedFilter: "Customer Name",
      expanded: [],
      singleExpand: true,
      isloadagents: false,
      skip: 0, // Initial skip value
      limit: 10000, // Initial limit value
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
      searchInputs: {
        fromdate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        todate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
    };
  },
  components: {
    BreadCrumb,
    // listOverviewVue
    Loading,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },
  watch: {
    userSelectedFilter(val) {
      if (val === "Customer ID") {
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Customer Name") {
        this.searchInputs.customer_id = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "ID Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Email ID") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Phone Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
      } else {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      }
    },
  },
  mounted() {
    if (this.isPreviousState) {
      const previousState = this.isPreviousState;
      this.searchInputs.customer_type =
        previousState.customer_type === "ALL"
          ? null
          : previousState.customer_type;
      this.searchInputs.customer_id = previousState.customer_id;
      this.searchInputs.customer_name = previousState.customer_name;
      this.searchInputs.id_number = previousState.id_number;
      this.searchInputs.user_email = previousState.user_email;
      this.searchInputs.phone_number = previousState.phone_number;
      this.searchInputs.account_status =
        previousState.account_status === "All"
          ? null
          : previousState.account_status;
      this.searchInputs.kyc_status =
        previousState.kyc_status === "ALL" ? null : previousState.kyc_status;
      this.searchInputs.from_date = previousState.from_date;
      this.searchInputs.to_date = previousState.to_date;
      this.searchInputs.txn_from_date = previousState.txn_from_date;
      this.searchInputs.txn_to_date = previousState.txn_to_date;
      this.getRemitteList();
    }
    console.log("queryery", this.$route.query.Totalcus_rejected);
    console.log(this.$store.state);
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
    logComponentPath() {
      const currentPath = this.$route.path;
      console.log("Current Component Path:", currentPath);
    },

    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
      }
    },
    async getRemitteList() {
      this.isloadagents = true;
      console.log("rrr", this.searchInputs.customer_type);
      try {
        const params = {
          customer_type: this.searchInputs.customer_type
            ? this.searchInputs.customer_type
            : "ALL",
          customer_id: this.searchInputs.customer_id,
          customer_name: this.searchInputs.customer_name,
          id_number: this.searchInputs.id_number,
          user_email: this.searchInputs.user_email,
          phone_number: this.searchInputs.phone_number,
          account_status: this.searchInputs.account_status
            ? this.searchInputs.account_status
            : "All",
          kyc_status: this.searchInputs.kyc_status
            ? this.searchInputs.kyc_status
            : "ALL",
          from_date: this.searchInputs.from_date,
          to_date: this.searchInputs.to_date,
          txn_from_date: this.searchInputs.txn_from_date,
          txn_to_date: this.searchInputs.txn_to_date,
          skip: this.skip,
          limit: this.limit,
        };
        const response = await userService.getRemittenceList(params);
        if (response.status === 200) {
          this.isloadagents = false;
          this.userList = response.data.data;
          // to store the state of the page (handle page when route back )
          this.$store.dispatch("savePreviousPageState", {
            customer_type: this.searchInputs.customer_type
              ? this.searchInputs.customer_type
              : "ALL",
            customer_id: this.searchInputs.customer_id,
            customer_name: this.searchInputs.customer_name,
            id_number: this.searchInputs.id_number,
            user_email: this.searchInputs.user_email,
            phone_number: this.searchInputs.phone_number,
            account_status: this.searchInputs.account_status
              ? this.searchInputs.account_status
              : "All",
            kyc_status: this.searchInputs.kyc_status
              ? this.searchInputs.kyc_status
              : "ALL",
            from_date: this.searchInputs.from_date,
            to_date: this.searchInputs.to_date,
            txn_from_date: this.searchInputs.txn_from_date,
            txn_to_date: this.searchInputs.txn_to_date,
            skip: this.skip,
            limit: this.limit,
          });
        }
        // else if (response.status === 401) {
        //   this.getRemitteList();
        // }
        else {
          // this.stoploader();
        }
      } catch (error) {
        // this.stoploader();
        console.error(error);
      }
    },

    async totalcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async todayRegcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayRegCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("todayRegcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalINDcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalINDcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalBUScuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalBUScuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.totalRejectedcus();
        // }
        console.log("totalRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async INDRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.INDRejectedcus();
        // }
        console.log("INDRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async BUSRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.BUSRejectedcus();
        // }
        console.log("BUSRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaproval() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaproval", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllhold() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getAllHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.getAllhold();
        // }
        console.log("getAllhold", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.getAllholdIND();
        // }
        console.log("getAllholdIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.getAllholdBUS();
        // }
        console.log("getAllholdBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },

    getRiskLabel(riskVal) {
      if (riskVal >= 0 && riskVal <= 50) {
        return "Low risk";
      } else if (riskVal > 50 && riskVal <= 80) {
        return "Medium risk";
      } else {
        return "High risk";
      }
    },
    nextpage(item) {
      console.log("data ", item);
      this.$router.push({
        name: "Transactions",

        query: {
          id: item.login_id,
          customerid: item.customer_id,
          user_type: item.user_type,
        },
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
</style>
